import React from 'react';

interface SectionTitleProps {
  title: string;
  className?: string;
  style?: React.CSSProperties;
}

export default function SectionTitle({ title, className, style }: SectionTitleProps) {
  return (
    <div className={className} style={style}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <span
          style={{
            display: 'inline-block',
            width: '4px',
            height: '16px',
            backgroundColor: '#105FC8',
            marginRight: '8px',
          }}
        />
        <span
          style={{
            color: '#292C33',
            fontSize: '16px',
            fontWeight: 600,
          }}
        >
          {title}
        </span>
      </div>
    </div>
  );
}